export { DocumentTemplates } from './DocumentTemplates.main';
